/**
 * Service Worker registration helper
 * - Registers /service-worker.js after page load
 * - Listens for updates and prompts a soft reload
 */
export function registerSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Don't register on localhost dev to avoid stale caches during HMR
  if (window.location.hostname === "localhost") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Listen for updates
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New version available — silent log; consumers can show a toast
              console.info("[PWA] New version available, refresh to update.");
            }
          });
        });
      })
      .catch((err) => {
        console.warn("[PWA] Service worker registration failed:", err);
      });
  });
}
